<template>
    <div>               
        
        <!-- Tabs -->
        <b-card 
            class="my-3" 
            footer-bg-variant="transparent">                 
            <b-card      
                header="Formulário Parâmetros"
                header-tag="header">
                <b-form inline>
                    <b-card 
                        header="Abertura de Sistema para o Cidadão"
                        header-tag="header"
                        class="col-12 p-0 my-2"
                        >
                        <b-row>
                           <b-col class="col-md-6 col-sm-12"> 
                            <b-form-group
                                label="Data de Abertura"
                                >
                                    <b-form-input  
                                        id="data_abertura_publico"                                                                    
                                        v-model="$v.parametro.data_abertura_publico.$model"
                                        @change="alteraDados"  
                                        :class="($v.parametro.data_abertura_publico.$error ? ` is-invalid` : ``)"                                        
                                        type="date"   
                                        :min="obterDataInicio()"
                                        :max="$helpers.getLastDayMonth(parametro.ano_referencia, parametro.mes_referencia)"   

                                    >
                                    </b-form-input>    
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_abertura_publico.required">Campo Obrigatório.</b-form-invalid-feedback>                                                 
                                </b-form-group>
                            </b-col> 
                            <b-col class="col-md-6 col-sm-12"> 
                            <b-form-group
                                label="Data de Fechamento"                
                                >
                                   <b-form-input  
                                        id="data_fechamento_publico"                                                                    
                                        v-model="$v.parametro.data_fechamento_publico.$model"
                                        @change="alteraDados"                                       
                                        :class="($v.parametro.data_fechamento_publico.$error ? ` is-invalid` : ``)"  
                                        type="date"
                                        :min="obterDataInicio()"
                                        :max="$helpers.getLastDayMonth(parametro.ano_referencia, parametro.mes_referencia)"   

                                    >
                                    </b-form-input>  
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_fechamento_publico.required">Campo Obrigatório.</b-form-invalid-feedback>     
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_fechamento_publico.isBiggerThanDataAberturaPublico">A Data de Fechamento deve ser maior ou igual a Data de Abertura.</b-form-invalid-feedback> 
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_fechamento_publico.verificaDataAtual">A Data de Fechamento deve ser maior ou igual a Data Atual.</b-form-invalid-feedback>         
                                    <!-- <b-form-invalid-feedback v-if="!$v.parametro.data_fechamento_publico.isBiggerThanStartDate">A Data deve ser maior ou igual a hoje.</b-form-invalid-feedback>      -->
                                </b-form-group>
                            </b-col> 
                        </b-row>  
                    </b-card>
                    
                    <!-- <b-card 
                        header="Geração de Arquivos para o Banco"
                        header-tag="header"
                        class="col-12 p-0 my-2"
                        >
                        <b-row>
                           <b-col class="col-md-6 col-sm-12"> 
                            <b-form-group
                                label="Data Início"
                                label-for="data_inicio_geracao_arquivo"                    
                                label-align-sm="right"
                                label-cols-md="3"
                                content-cols-sm="12"  
                                content-cols-md="9"
                                >
                                    <b-form-input  
                                        id="data_inicio_geracao_arquivo"                                                                    
                                        v-model="$v.parametro.data_inicio_geracao_arquivo.$model"
                                        @change="alteraDados"
                                        :class="($v.parametro.data_inicio_geracao_arquivo.$error ? ` is-invalid` : ``)"                                        
                                        type="date"
                                        :readonly="!this.parametro.ano_referencia || !this.parametro.mes_referencia || this.campoBloqueado.data_inicio_geracao_arquivo"                                    
                                        :min="obterDataInicio()"
                                        :max="$helpers.getLastDayMonth(parametro.ano_referencia, parametro.mes_referencia)"   
                                    >
                                    </b-form-input>    
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_inicio_geracao_arquivo.required">Campo Obrigatório.</b-form-invalid-feedback>     
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_inicio_geracao_arquivo.isBiggerThanDataFimCargaFamilia">A Data Início de Geração de Arquivos para o Banco deve ser maior que a Data Fim de Abertura para o Cidadão.</b-form-invalid-feedback>     
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_inicio_geracao_arquivo.isBiggerThanStartDate">A Data deve ser maior ou igual a hoje.</b-form-invalid-feedback>     
                                </b-form-group>
                            </b-col> 
                            <b-col class="col-md-6 col-sm-12"> 
                            <b-form-group
                                label="Data Fim"
                                label-for="data_fim_geracao_arquivo"                    
                                label-align-sm="right"                                
                                label-cols-md="3"
                                content-cols-sm="12"  
                                content-cols-md="9"
                                >
                                   <b-form-input  
                                        id="data_fim_geracao_arquivo"                                                                    
                                        v-model="$v.parametro.data_fim_geracao_arquivo.$model"                                        
                                        @change="alteraDados"                               
                                        :class="($v.parametro.data_fim_geracao_arquivo.$error ? ` is-invalid` : ``)"  
                                        type="date"    
                                        :readonly="!this.parametro.ano_referencia || !this.parametro.mes_referencia || this.campoBloqueado.data_fim_geracao_arquivo"                                    
                                        :min="obterDataInicio()"
                                        :max="$helpers.getLastDayMonth(parametro.ano_referencia, parametro.mes_referencia)"  
                                    >
                                    </b-form-input>  
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_fim_geracao_arquivo.required">Campo Obrigatório.</b-form-invalid-feedback>     
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_fim_geracao_arquivo.isBiggerThanDataAberturaPublico">A Data Fim de Geração de Arquivos para o Banco deve ser maior ou igual a Data Ínicio.</b-form-invalid-feedback>     
                                    <b-form-invalid-feedback v-if="!$v.parametro.data_fim_geracao_arquivo.isBiggerThanStartDate">A Data deve ser maior ou igual a hoje.</b-form-invalid-feedback>     
                                </b-form-group>
                            </b-col> 
                        </b-row>  
                    </b-card> -->
                </b-form>                           
       
            </b-card> 
            <template v-slot:footer >                                  
                <b-row >  
                    <b-col class="text-left">   
                        <b-button                                               
                            variant="outline-secondary"                   
                            @click.prevent="voltar" 
                            title="Voltar">
                                <font-awesome-icon                                                                      
                                    :icon="['fas','arrow-left']"
                                    title="Voltar"
                                    class="mr-1"
                                />
                                Voltar
                        </b-button>
                    </b-col>    
                    <b-col class="text-right" >                    
                        <b-button                                               
                            variant="success"                   
                            @click.prevent="salvar" 
                            title="Salvar">
                                <font-awesome-icon                                                                      
                                    :icon="['fas','save']"
                                    title="Salvar"
                                    class="mr-1"
                                />
                                Salvar
                        </b-button>                                
                    </b-col>                          
                </b-row>
            </template>
       </b-card>
    </div>  
</template>

<script>

import moment from 'moment'
import { required } from "vuelidate/lib/validators";
import Parametro from "../../../models/Parametro";


export default {

    data(){
        return { 
            parametro: new Parametro(),                         
            formAlterado: false, 
            optionsAnoReferencia: [], 
            optionsMesReferencia: [
                { value: null, text: 'Selecione um mês' },
                { value: 1, text: 'Janeiro' },
                { value: 2, text: 'Fevereiro' },
                { value: 3, text: 'Março' },
                { value: 4, text: 'Abril' },
                { value: 5, text: 'Maio' },
                { value: 6, text: 'Junho' },
                { value: 7, text: 'Julho' },
                { value: 8, text: 'Agosto' },
                { value: 9, text: 'Setembro' },
                { value: 10, text: 'Outubro' },
                { value: 11, text: 'Novembro' },
                { value: 12, text: 'Dezembro' }                
            ],
            acao: null,
            campoBloqueado:{
                //data_inicio_carga_familia: false, 
                //data_fim_carga_familia: false,
                data_abertura_publico: false, 
                data_fechamento_publico: false, 
                //data_inicio_geracao_arquivo: false,
                //data_fim_geracao_arquivo: false,                 
            },

            hoje: moment().format('YYYY-MM-DD'),  //Dia de hoje   
            mesAtual: moment(this.hoje).format('YYYY-MM'),                          
        }
    },
    
    validations: {
        parametro: {
            // ano_referencia: {
            //     required,
            // },

            // mes_referencia: {
            //     required,        
            // },

            // data_inicio_carga_familia: {
            //     required,
            //     isBiggerThanStartDate: (function(value) { 
            //         return value >= this.obterDataInicio() || this.acao == 'edit';
            //     }),         
            // },

            // data_fim_carga_familia: {
            //     required,  
            //     isBiggerThanDataInicioCargaFamilia: (function (value) {                    
            //         return value >= this.parametro.data_inicio_carga_familia;                                    
            //     }),
            //     isBiggerThanStartDate: (function(value) { 
            //         return value >= this.obterDataInicio() || this.acao == 'edit';
            //     }),          
            // },

            data_abertura_publico: {
                required,
            },

            data_fechamento_publico: {
                required,  
                isBiggerThanDataAberturaPublico: (function (value) {
                    return value >= this.parametro.data_abertura_publico;                                    
                }),
                verificaDataAtual: (function (value) {
                    return (moment(value).isAfter(this.hoje)) || (value == this.hoje);                                       
                }),
                // isBiggerThanStartDate: (function(value) { 
                //     return value >= this.obterDataInicio() || this.acao == 'edit';
                // }),      
            },

            // data_inicio_geracao_arquivo: {
            //     required,  
            //     isBiggerThanDataFechamentoPublico: (function (value) {
            //         return value > this.parametro.data_fechamento_publico;                                    
            //     }),
            //     isBiggerThanStartDate: (function(value) { 
            //         return value >= this.obterDataInicio() || this.acao == 'edit';
            //     }),       
            // },

            // data_fim_geracao_arquivo: {
            //     required,                     
            //     isBiggerThanDataInicioGeracaoArquivo: (function (value) {                    
            //         return value >= this.parametro.data_inicio_geracao_arquivo;                                    
            //     }),
            //     isBiggerThanStartDate: (function(value) { 
            //         return value >= this.obterDataInicio() || this.acao == 'edit';
            //     }),                     
            // },
        }
    },



    methods: {          
        
        alteraDados(){
            this.formAlterado = true;
        },


        obterDataInicio(){            
            if(this.parametro.ano_referencia && this.parametro.mes_referencia) {               
                let mesReferencia = moment([this.parametro.ano_referencia, this.parametro.mes_referencia -1]).format('YYYY-MM');                      
                if(this.mesAtual === mesReferencia){
                    return this.hoje;      
                }else{
                    return this.$helpers.getFirstDayMonth(this.parametro.ano_referencia, this.parametro.mes_referencia);
                }                            
            }
            else{
                return null;
            }             
        },


        obter(id){                 
            return this.$api.get(`parametros/${id}`)
                .then(response => {  
                    if(response.status == 200){                                                
                        this.parametro = new Parametro(response.data.dados);                                                                            
                    }                                                            
                })
                .catch(error => {   
                    if(error.response.data){                        
                        this.$helpers.showToast(this, 'Erro', error.response.data.message, 'danger');                        
                    }                                                                          
                });                                                 
        },

        editar(){
            this.$api.put(`parametros/${this.parametro.id}`, this.parametro)
                .then(response => {                    
                    if(response.status === 200 ){         
                        this.parametro = new Parametro(response.data.dados);                                        
                        this.formAlterado = false; 
                        this.$helpers.showToast(this, 'Sucesso', response.data.message, 'success');                                        
                    } 
                })
                .catch(error => {                               
                    if(error.response.data){                        
                        this.$helpers.showToast(this, 'Erro', error.response.data.message,' danger');                        
                    } 
                });  
        },        


        incluir(){          
              this.$api.post('parametros', this.parametro)
                .then(response => {                    
                    if(response.status === 201){               
                        this.parametro = new Parametro(response.data.dados);                              
                        this.formAlterado = false;
                        this.$helpers.showToast(this, 'Sucesso', response.data.message, 'success');   
                        this.$router.push("/admin/parametros/"+this.parametro.id);
                        //this.start();
                    }
                })
                .catch(error => {  
                    if(error.response.data){                        
                        this.$helpers.showToast(this, 'Erro', error.response.data.message, 'danger');                        
                    } 
                });
        },


        salvar(){    

           /* if(moment(this.parametro.data_fechamento_publico).isBefore(this.hoje)){
                this.$helpers.showToast(this, 'Erro', 'Não é possivel inserir uma data de fechamento anterior a data atual.', 'danger');        
                return;
            }*/
            
            this.$v.$touch()
            if (!this.$v.$invalid){  
                    this.incluir();                                                        
            }                  
        },

        voltar(){
            if(this.formAlterado){
               this.$helpers.confirmaVoltar(this)
                    .then(confirmado => { 
                        if(confirmado){                        
                            this.$router.push({ name: 'parametros'});
                        } 
                    });
            } else {
                 this.$router.push({ name: 'parametros'}); 
            }
        },

        setNovoRegistro(){
            //Ano Referencia
            let anoCorrente = new Date().getFullYear()
            this.optionsAnoReferencia.push(anoCorrente);
            this.optionsAnoReferencia.push(anoCorrente + 1);                                 
        },

        setRegistroExistente(){
            this.optionsAnoReferencia.push(this.parametro.ano_referencia);
            this.campoBloqueado.data_abertura_publico = this.parametro.data_abertura_publico < this.hoje ? true : false;
            this.campoBloqueado.data_fechamento_publico = this.parametro.data_fechamento_publico < this.hoje ? true : false;           
        },
        

        async start(){
            if(this.$route.params.id === 'new'){
                this.acao = 'new';
                this.parametro = new Parametro();
                this.setNovoRegistro();
            }else{
                this.acao = 'edit';
                await this.obter(this.$route.params.id);
                this.setRegistroExistente();
            }
        }
    },    
   
    mounted(){   
        this.start();       
    },

}
</script>


